import { render, staticRenderFns } from "./CustomDraggable.vue?vue&type=template&id=152137b0&scoped=true&"
import script from "./CustomDraggable.vue?vue&type=script&lang=ts&"
export * from "./CustomDraggable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDraggable.vue?vue&type=style&index=0&id=152137b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152137b0",
  null
  
)

export default component.exports